import React, { Component } from 'react';
import styled from 'styled-components';
import { getTheme } from '../../global/utils';
import Button from '../../components/buttons/Button';
import Heading from '../../components/text/Heading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { faChartLine } from '@fortawesome/pro-light-svg-icons';

const CardNoResultsWrapper = styled.div`
  text-align: center;
  .noresults__icon {
    color: ${getTheme('textColor', 'baseLight')};
    font-size: ${getTheme('fontSize', 'display')};
  }
  .noresults__heading {
    font-weight: 300;
    color: ${getTheme('textColor', 'altLight')};
  }
  .noresults__text {
    font-size: ${getTheme('fontSize', 'note')};
    font-weight: 600;
  }
`;

class CardNoResults extends Component {
  render() {
    return (
      <CardNoResultsWrapper className={this.props.className}>
        <div className="noresults">
          <div className="noresults__icon">
            <FontAwesomeIcon icon={faChartLine} />
          </div>
          <Heading level="heading2">
            <h3 className="noresults__heading">
              There are no variable charts yet
            </h3>
          </Heading>
          <Button
            secondary
            size="xsmall"
            onClick={this.props.handleClick}
            iconBefore={<FontAwesomeIcon icon={faPlus} />}
          >
            Add Chart
          </Button>
        </div>
      </CardNoResultsWrapper>
    );
  }
}

export default CardNoResults;



// WEBPACK FOOTER //
// ./src/pages/alarms/AlarmsNoResults.js